import { Flex, Spacing } from '@billy/design-system'
import { ReactNode } from 'react'

import * as Styled from './styles'

interface InvoiceColumnsVisibilitySettingsSectionProps {
  children?: ReactNode
}

export const InvoiceColumnsVisibilitySettingsSection = ({ children }: InvoiceColumnsVisibilitySettingsSectionProps) => {
  return (
    <Styled.InvoiceColumnsVisibilitySettingsSection>
      <Flex flexDirection="column" gap={Spacing.S16}>
        {children}
      </Flex>
    </Styled.InvoiceColumnsVisibilitySettingsSection>
  )
}
